var debug = require('debug')('CRMMap:Filters');
var Helpers = require('../utils');


class Filters {

    constructor(CRMMap) {
        this.CRMMap = CRMMap;
        this.clear();
    }

    set(name, value) {
        this.filters[name] = value;
        debug('SetFilter', name, value, this.filter);
    }

    update(control) {
        this.filters[control.name] = control.value;
        this.CRMMap.updatePins();
    }

    clear() {
        this.filters = [];
    }

    all() {
        return this.filters;
    }


}
module.exports = Filters;
